<file-manager [initialPath]="hrInitialPath" [featureKey]="'IT_FILE_MANAGER'"></file-manager>
